import { render } from "./HypoChart.vue?vue&type=template&id=9b6b7a80"
import script from "./HypoChart.vue?vue&type=script&lang=js"
export * from "./HypoChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__